var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.sectionData
    ? _c(
        "section",
        {
          staticClass: "highlightSection",
          class: {
            "highlightSection__row-reverse": _vm.setRowReverse,
          },
          attrs: {
            id: _vm.sectionData.sectionKey,
            "data-observe": "",
            "aria-labelledby": `highlightSection__${_vm.sectionData.name}`,
          },
        },
        [
          _c(
            "div",
            { staticClass: "highlightSection__text" },
            [
              _c(
                "h3",
                {
                  staticClass:
                    "hl-module margin-bottom-0 text-color--primary-contrast",
                  attrs: { id: `highlightSection__${_vm.sectionData.name}` },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getSectionMetaData.title) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "h3" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.getSectionMetaData.subTitle) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "margin-bottom-30",
                domProps: { innerHTML: _vm._s(_vm.getSectionMetaDataText) },
              }),
              _vm._v(" "),
              _vm.sectionData.sectionKey === _vm.MARKET_SEGMENTS
                ? _c("ModalButton", {
                    attrs: {
                      "overlay-shown": _vm.overlayShown,
                      "active-outlook": _vm.activeOutlook,
                      "market-data": _vm.marketData,
                      "button-title": _vm.trans("OUTLOOK_SHOW_MARKET_DETAILS"),
                      "data-gtm": "highlights__treeMap--openModal",
                    },
                    on: { "is-open": _vm.toggleOverlay },
                  })
                : _vm.sectionData.sectionKey === _vm.GLOBAL_COVERAGE
                ? _c("ModalButton", {
                    attrs: {
                      "overlay-shown": _vm.overlayShown,
                      "active-outlook": _vm.activeOutlook,
                      "button-title": _vm.trans(
                        "XMO_HIGHLIGHTS_GLOBAL_MAP_SEE_COUNTRIES"
                      ),
                      "data-gtm": "highlights__globalMap--openModal",
                    },
                    on: { "is-open": _vm.toggleOverlay },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          [
            _vm.isIconChart
              ? _c("HighlightsIconChart", {
                  attrs: { "section-chart-data": _vm.sectionChartData },
                })
              : _c(
                  "div",
                  { staticClass: "highlightChart" },
                  [
                    _c("div", {
                      staticClass: "hideMobile",
                      class: _vm.getBackgroundClass,
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: _vm.defaultDisplayType,
                        class: _vm.getWrapperClass,
                      },
                      [
                        _c("HighlightsChart", {
                          attrs: {
                            chart: _vm.chart,
                            "chart-title": _vm.chartTitle,
                            "chart-type": _vm.defaultDisplayType,
                          },
                          on: { "set-category": _vm.setSelectedCategory },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.canShowNextChartButton
                      ? _c("NextChartButton", {
                          attrs: {
                            "section-chart-data": _vm.sectionChartData,
                            "is-disabled": _vm.isNextButtonDisabled,
                          },
                          on: { "set-chart-selection": _vm.changeCurrentChart },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ],
          _vm._v(" "),
          _c("Overlay", {
            attrs: { "overlay-shown": _vm.overlayShown },
            on: {
              "toggle-modal": function ($event) {
                return _vm.toggleOverlay(false)
              },
            },
          }),
        ],
        2
      )
    : _c(
        "div",
        {
          staticClass:
            "margin-top-50 animated fadeIn z-index-1 width100 text-center",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "h5 subline margin-bottom-0" }, [
            _vm._v("\n        " + _vm._s(_vm.trans("PLEASE_WAIT")) + "\n    "),
          ]),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cssPreloader" }, [
      _c("div", { staticClass: "cssPreloader__inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }